<template>
  <div class="modal outside-country" v-show="getInfoPopup">
    <div class="modal__content">
      <h3 class="modal__title">Шановні учасники програми!</h3>
      <div class="modal__main">
        <div class="modal__text">
          Інформуємо, що з 1 червня 2026 р. набирають чинності оновлені обмеження щодо максимальної кількості лікарських
          засобів, які один учасник Програми може придбати протягом місяця, використовуючи картку учасника Програми, а
          саме:
          <br>
          <ul>
            <li>
              не більше 3 (трьох) упаковок одного лікарського засобу протягом місяця;
            </li>
            <li>
              не більше 6 (шести) упаковок різних найменувань лікарських засобів, включених до Програми, протягом
              місяця.
            </li>
          </ul>
          З усіх питань ви можете <strong>звернутися</strong> на гарячу лінію <strong>за номером телефону <a
            href="tel:0800211202">0 800 211 202</a></strong>
          <br>
          <i>(щоденно з 9:00 до 21:00, дзвінки з усіх телефонних номерів у межах України безкоштовні).</i>
          <br>
          <br>
          <strong>Дякуємо!</strong>
          <br>
          <strong>З повагою,</strong>
          <br>
          <strong>Компанія «АстраЗенека Україна»,</strong>
          <br>
          Організатор програми підтримки пацієнтів <strong>«ТерапіяПЛЮС»</strong>
        </div>

        <div class="modal__options">
          <a href="#" @click.prevent="closeModal" class="modal__btn">
            ознайомлений/ознайомлена
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapMutations} from "vuex";

export default {
  name: "info",
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["getInfoPopup"])
  },
  methods: {
    ...mapMutations(["setInfoPopUp"]),
    closeModal() {
      this.setInfoPopUp(false);
      localStorage.setItem("info", "true")
    },
  }
};
</script>

<style lang="scss" scoped>
.modal {

  &__content {
    overflow-y: auto;

    @media screen and (min-width: 768px) and (max-height: 924px) {
      max-height: 90vh;
    }

    @media screen and (max-width: 768px) {
      max-height: 90vh;
    }
  }

  &__text {
    text-align: left;
    font-size: 14px;
    line-height: 1.5em;

    ul {
      margin-top: 10px;
      padding-left: 20px;
      li{

        margin-bottom: 5px;
      }
    }

    a {
      color: inherit;
      white-space: nowrap;
    }

    i {
      font-style: italic;
    }

    strong {
      font-weight: bold;
    }

    span {
      &:last-child {
        font-size: 10px;
      }
    }
  }
}
</style>